import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import UserItem from '../components/UserItem';
import CreateUserForm from '../components/CreateUserForm';
import EditUserForm from '../components/EditUserForm';
import DeleteUserDialog from '../components/DeleteUserDialog';
import { fetchAllUsers } from '../services/userService';

function UserManagementPage() {
  const token = useSelector((state: RootState) => state.auth.token);
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [editUser, setEditUser] = useState<any | null>(null);
  const [deleteUser, setDeleteUser] = useState<any | null>(null);

  useEffect(() => {
    if (!token) return;

    const loadUsers = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await fetchAllUsers(token!);
        setUsers(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [token]);

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Nutzerverwaltung</h3>

      {error && <div className="alert alert-danger">{error}</div>}

      <button className="btn btn-primary mb-3" onClick={() => setShowCreate(true)}>
        Neuen Nutzer anlegen
      </button>

      {loading ? (
        <p>Lädt...</p>
      ) : (
        <ul className="list-group">
          {users.map((user) => (
            <UserItem
              key={user._id}
              user={user}
              onEdit={() => setEditUser(user)}
              onDelete={() => setDeleteUser(user)}
            />
          ))}
        </ul>
      )}

      {showCreate && (
        <CreateUserForm
          onClose={() => setShowCreate(false)}
          onSuccess={() => {
            setShowCreate(false);
            token && fetchAllUsers(token).then(setUsers);
          }}
        />
      )}

      {editUser && (
        <EditUserForm
          user={editUser}
          onClose={() => setEditUser(null)}
          onSuccess={() => {
            setEditUser(null);
            token && fetchAllUsers(token).then(setUsers);
          }}
        />
      )}

      {deleteUser && (
        <DeleteUserDialog
          user={deleteUser}
          onClose={() => setDeleteUser(null)}
          onSuccess={() => {
            setDeleteUser(null);
            token && fetchAllUsers(token).then(setUsers);
          }}
        />
      )}
    </div>
  );
}

export default UserManagementPage;
